module.exports = __webpack_public_path__ + "fr.svg?ad12a30fa4e7ad78b1f1af7164f8dae5";